import { TransactionStatus, TransactionStatusDescriptions, YesNo } from "../../../../enum/Enum";

// Page-level tab indexes. Start jumps to SUMMARY, Create returns to CALCULATE, and the help text
// is keyed off the active tab (uWMD0088.pas:428, :491, :721-743).
export const TAB = Object.freeze({
    CALCULATE: 0,
    SUMMARY: 1,
    DETAIL: 2,
    BY_CUSTOMER: 3,
    BY_CUSTOMER_DEPT: 4,
});

// Parameter field names, shared by Layout.js (the schema) and the page (formRefs lookups,
// validation and the Acct Source rule). Declared once so a rename cannot silently break the
// page's imperative field access, which is keyed by these exact strings.
export const FIELD = Object.freeze({
    AsOfDate: "AsOfDate",
    Status: "Status",
    Reference: "Reference",
    AcctSource: "AcctSource",
    DebitAccount: "DebitAccount",
    DebitActivity: "DebitActivity",
    UseMgtUnits: "UseMgtUnits",
    CreditAccount: "CreditAccount",
    CreditActivity: "CreditActivity",
});

// WMD0088 "Acct Source" combo. Nothing equivalent exists in enum/Enum.js, so it is declared here;
// Status and Use Mgt Units reuse TransactionStatus / YesNo.
export const AcctSource = Object.freeze({
    ChargeCode: "C",
    UserEntered: "U",
});

// ACJOURNALHEADER.STATUS. The codes are the stored codes, sent straight through — the legacy R->L
// mapping existed only because the Delphi combo item text began with "R".
export const STATUS_OPTIONS = [
    { key: TransactionStatus.Open, value: TransactionStatusDescriptions.Open },
    { key: TransactionStatus.Hold, value: TransactionStatusDescriptions.Hold },
    { key: TransactionStatus.ReadyToCommitLater, value: TransactionStatusDescriptions.ReadyToCommitLater },
];

export const ACCT_SOURCE_OPTIONS = [
    { key: AcctSource.ChargeCode, value: "Charge Code" },
    { key: AcctSource.UserEntered, value: "User Entered" },
];

export const USE_MGT_UNITS_OPTIONS = [
    { key: YesNo.Yes, value: "Yes, use the management units from the charge codes" },
    { key: YesNo.No, value: "No, do not use management units" },
];

// Dynamic-form layout identity for the Calculate parameters panel.
export const LAYOUT_ID = "7C4E9A21-5D38-4B6F-9E02-3A17D8C5B940";
export const LAYOUT_NAME = "WMCalculateDeferredRevenueForm";

// Filter-field definitions come from Argos.Core/Report/WM/WMCalculateDeferredRevenue.cs via
// ReportFactory's "WMCALCULATEDEFERREDREVENUE" case.
export const REPORT_NAME = "WMCalculateDeferredRevenue";
export const REPORT_FULL_NAME = "Argos.Report.WM.WMCalculateDeferredRevenue, Argos.Report.WM";

// The five context-sensitive help strings, verbatim from uWMD0088.pas:721-743.
export const DEFERRED_REVENUE_HELP = Object.freeze({
    [TAB.CALCULATE]:
        "This program calculates the Deferred (unearned) revenue based on the on-hand quantity on the As Of Date specified by you. " +
        "After the calculation is completed you will have the option of creating an AC Reversing Journal Transaction using the results provided.",
    [TAB.SUMMARY]:
        "To apply these changes hit the Create Unposted AC Journal Transaction button below. This will create an Unposted AC Reversing " +
        "Journal Entry that can be modified, printed and/or committed in the AC module.",
    [TAB.DETAIL]:
        "The detail tab shows a breakout of the Deferred (unearned) revenue by Customer/Item/Lot/Charge Code.",
    [TAB.BY_CUSTOMER]:
        "The customer tab shows a summary of the Deferred (unearned) revenue by Customer.",
    [TAB.BY_CUSTOMER_DEPT]:
        "The customer/department tab shows a summary of the Deferred (unearned) revenue by Customer/Department.",
});

export const PAGE_TITLE = "Calculate Deferred Handling Revenue";

// ACJOURNALHEADER.REFERENCE is varchar(30).
export const REFERENCE_MAX_LENGTH = 30;

// The Calculate call runs the stored procedure four times; the legacy allowed 900s per call.
export const REQUEST_TIMEOUT_MS = 15 * 60 * 1000;
